import React, { Suspense, lazy } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { PublicPageViewer } from './pages/PublicPageViewer'; // Keep eager for speed

// Lazy load all admin components
const AdminLayout = lazy(() => import('./layouts/AdminLayout').then(m => ({ default: m.AdminLayout })));
const Dashboard = lazy(() => import('./pages/Dashboard').then(m => ({ default: m.Dashboard })));
const SitesList = lazy(() => import('./pages/SitesList').then(m => ({ default: m.SitesList })));
const SiteDetail = lazy(() => import('./pages/SiteDetail').then(m => ({ default: m.SiteDetail })));
const AllPages = lazy(() => import('./pages/AllPages').then(m => ({ default: m.AllPages })));
const PageEditor = lazy(() => import('./pages/PageEditor').then(m => ({ default: m.PageEditor })));
const PagePreview = lazy(() => import('./pages/PagePreview').then(m => ({ default: m.PagePreview })));
const Login = lazy(() => import('./pages/Login').then(m => ({ default: m.Login })));
const Analytics = lazy(() => import('./pages/Analytics').then(m => ({ default: m.Analytics })));

function App() {
  const path = window.location.pathname;
  if (path.startsWith('/p/')) {
    const slug = path.replace('/p/', '').replace(/\/$/, '');
    return <PublicPageViewer slug={slug} />;
  }

  return (
    <AuthProvider>
      <HashRouter>
        <Suspense fallback={<div className="flex h-screen w-full items-center justify-center"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600" /></div>}>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/pages/:pageId/preview" element={<PagePreview />} />
            
            <Route path="/dashboard" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="sites" element={<SitesList />} />
              <Route path="sites/:siteId" element={<SiteDetail />} />
              <Route path="pages" element={<AllPages />} />
              <Route path="pages/new" element={<PageEditor />} />
              <Route path="pages/:pageId/edit" element={<PageEditor />} />
              <Route path="analytics" element={<Analytics />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </HashRouter>
    </AuthProvider>
  );
}

export default App;